import React from "react";
import { Route, Redirect } from "react-router-dom";
import API from '../API';

export const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={
                (props) =>
                {
                    if (API.getInstance().hasActiveSession())
                    {
                        //console.log('Has active session -> Go to page')
                        return <Component {...props} />
                    }
                    else
                    {
                        //console.log('No active session -> Redirect to /', JSON.stringify(props.location))
                        return <Redirect to={
                                {
                                    pathname: '/',
                                    search: props.location.search,
                                    state: { from: props.location }
                                }} />
                    }
                }
            }
        />
    )
}

export default PrivateRoute;
  